import appApi from '../../../../../api/app-api';
import { HourChangeRequestStatusType } from '../../../../../api/types/programs/course/course-hours-request-change/course-hours-request-change.type';

export const updateCourseHoursRequestStatusOperation = async (
  programId: number,
  courseId: number,
  requestId: number,
  status: HourChangeRequestStatusType,
  setLoading: (loading: boolean) => void,
) => {
  setLoading(true);

  try {
    await appApi.updateCourseHoursRequestStatus(
      programId,
      courseId,
      requestId,
      status,
    );
  } catch (error) {
    console.error('Error updating course hours request status:', error);
    throw error;
  } finally {
    setLoading(false);
  }
};
